/* eslint-disable import/prefer-default-export */
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Space, Layout } from 'antd';
import React from 'react';
import styled from 'styled-components';
import Button from '../Button';

const ContainerNav = styled(Layout.Header)`
  padding-inline: 20px;
  background: #f0f5ff;
`;

const WrappedNav = styled(Space)`
  width: 100%;
  > .ant-space-item:nth-child(odd) {
    // Left and Right Side.
    flex: auto 0.5;
  }
  > .ant-space-item:nth-child(even) {
    flex: auto;
  }
`;

const Left = styled.div`
  text-align: left;
`;

const Center = styled.div`
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.42px;
`;
const Right = styled.div`
  text-align: right;
`;

const NavBar = ({ containerProps, title, left, right, onBack }) => {
  const LeftSide = React.useMemo(() => {
    if (!left && onBack) {
      return <Button type="text" onClick={onBack} icon={<ArrowLeftOutlined />} />;
    }
    return (
      <Space>
        {onBack && <Button onClick={onBack} icon={<ArrowLeftOutlined />} />}
        {left}
      </Space>
    );
  }, [left, onBack]);
  return (
    <ContainerNav {...containerProps}>
      <WrappedNav>
        <Left>{LeftSide}</Left>
        <Center>{title}</Center>
        <Right>{right}</Right>
      </WrappedNav>
    </ContainerNav>
  );
};

export default NavBar;
